export default __webpack_public_path__ + "static/media/home_left.c184dd7b.png";